import { ENTITY_PLATFORMS } from 'constants/entityPlatforms';
import { amazon, dcm, dv360, facebook, innovid, linkedin, pinterest, twitter, ttd } from 'constants/platforms';

// Note - tv is first because its display name is currently Advanced TV and this list is alphabetical
// for the purpose of rendering
exports.ORDERED_CHANNEL_KEYS = ['tv', 'audio', 'display', 'mobile', 'native', 'sem', 'site', 'social', 'youtube', 'video'];
exports.HEATMAP_CHANNELS = ['display', 'mobile', 'native', 'video', 'audio', 'tv', 'site'];
exports.ATTRIBUTION_ACTIVITY_CHANNELS = ['display', 'mobile', 'native', 'video', 'audio', 'tv', 'site'];

// Entity form channel data sources
// TODO refactor this config so its information is contained within the channel mapping
// and exposed through a helper method
exports.CHANNEL_DS_CONFIG = {
    [ENTITY_PLATFORMS.ccms]: [
        { channel: 'audio', default: 'ttd' },
        { channel: 'display', default: 'dcm' },
        { channel: 'mobile', default: 'dcm' },
        { channel: 'native', default: 'dcm' },
        { channel: 'video', default: 'dcm' },
        { channel: 'tv', default: 'dcm' },
    ],
    [ENTITY_PLATFORMS.salesforce]: [
        { channel: 'audio', default: 'ttd' },
        { channel: 'display', default: 'ttd' },
        { channel: 'mobile', default: 'ttd' },
        { channel: 'native', default: 'ttd' },
        { channel: 'video', default: 'ttd' },
        { channel: 'tv', default: 'ttd' },
    ],
};

exports.PROGRAMMATIC_PLATFORMS = { dcm, ttd, amazon, dv360 };

exports.CHANNEL_MAPPING = {
    mobile: {
        key: 'mobile',
        displayName: 'Mobile',
        supported: true,
        defaultEnabledState: true,
        ccms: 'dcm',
        salesforce: 'ttd',
        deliveryPlatforms: exports.PROGRAMMATIC_PLATFORMS
    },
    video: {
        key: 'video',
        displayName: 'Video',
        supported: true,
        defaultEnabledState: true,
        ccms: 'dcm',
        salesforce: 'ttd',
        deliveryPlatforms: { ...exports.PROGRAMMATIC_PLATFORMS, innovid }
    },
    audio: {
        key: 'audio',
        displayName: 'Audio',
        supported: true,
        defaultEnabledState: true,
        ccms: 'ttd',
        salesforce: 'ttd',
        deliveryPlatforms: exports.PROGRAMMATIC_PLATFORMS
    },
    social: {
        key: 'social',
        displayName: 'Social',
        supported: true,
        defaultEnabledState: true,
        ccms: 'facebook',
        salesforce: 'facebook',
        deliveryPlatforms: { facebook, linkedin, pinterest, twitter }
    },
    native: {
        key: 'native',
        displayName: 'Native',
        supported: true,
        defaultEnabledState: true,
        ccms: 'dcm',
        salesforce: 'ttd',
        deliveryPlatforms: exports.PROGRAMMATIC_PLATFORMS
    },
    tv: {
        key: 'tv',
        displayName: 'Advanced TV',
        supported: true,
        defaultEnabledState: true,
        ccms: 'dcm',
        salesforce: 'ttd',
        deliveryPlatforms: exports.PROGRAMMATIC_PLATFORMS
    },
    site: {
        key: 'site',
        displayName: 'Site Direct',
        supported: true,
        defaultEnabledState: false,
        ccms: 'dcm',
        salesforce: 'dcm',
    },
    display: {
        key: 'display',
        displayName: 'Display',
        supported: true,
        defaultEnabledState: true,
        ccms: 'dcm',
        salesforce: 'ttd',
        deliveryPlatforms: { ...exports.PROGRAMMATIC_PLATFORMS, innovid }
    },
    sem: {
        key: 'sem',
        displayName: 'SEM',
        supported: true,
        defaultEnabledState: true
    },
    youtube: {
        key: 'youtube',
        displayName: 'YouTube',
        supported: true,
        defaultEnabledState: true
    },
};

exports.CUSTOM_CHANNEL_PLATFORMS = {
    gds: 'Google Data Studio',
    redash: 'Redash',
    other: ''
};



// WEBPACK FOOTER //
// ./src/constants/channels.js